var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CreateSpaceRepository } from './create-space-service.interface';
import { SpacesModel } from '../model/spaces-model';
let CreateSpaceServiceImpl = class CreateSpaceServiceImpl {
    constructor(_spacesModel, _createSpaceRepository) {
        this._spacesModel = _spacesModel;
        this._createSpaceRepository = _createSpaceRepository;
    }
    async createSpace(data) {
        const result = await this._createSpaceRepository.createSpace(data);
        this._spacesModel.update(entities => [result, ...entities]);
        return result;
    }
};
CreateSpaceServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SpacesModel)),
    __param(1, inject(CreateSpaceRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpacesModel !== "undefined" && SpacesModel) === "function" ? _a : Object, typeof (_b = typeof CreateSpaceRepository !== "undefined" && CreateSpaceRepository) === "function" ? _b : Object])
], CreateSpaceServiceImpl);
export { CreateSpaceServiceImpl };
